import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";
import { Link } from "react-router-dom";

function Returns() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="returns page">
      <Header />

      <div className="returns__wrap">
        <nav className="breadcrumb">
          <Link onClick={toTop} to="/">
            Home
          </Link>
          <span className="crumb-sep">&gt;</span>
          <span>Returns</span>
        </nav>

        <header className="returns__header">
          <h1 className="returns__title">RETURNS, REFUNDS, AND EXCHANGES</h1>
          <hr className="returns__rule" />
          <p className="returns__lead">
            You can return eligible items within 30 days of receiving an order
            or 7 days for In Stock upholstery items for a refund of the
            merchandise value. Depending on the reason for your return, you may
            be responsible for return shipping costs. An original receipt or
            gift receipt is required. We want you to be completely satisfied
            with your purchase, however, custom lighting and Made to Order
            furniture are not eligible for returns.
          </p>
          <p className="returns__lead">
            We're here to help walk you through these decisions. Please call us
            with any questions at{" "}
            <Link onClick={toTop} to="tel:8884011900">
              888-401-1900
            </Link>
            . If you live near one of our retail locations, our knowledgeable
            sales associates will be able to answer all your questions.
          </p>
          <p className="returns__lead">
            Please inspect your products immediately upon delivery to notify us
            of any damaged, incomplete, or inaccurate shipments, and we'll fix
            the issue or offer you a full refund. A receipt is required for all
            returns and exchanges. To receive a full refund, all merchandise
            must be in its original packaging and original condition, with all
            installation hardware and original receipt included. Shipping and
            handling fees are not refundable. We will provide return shipping
            labels for defective products or shipping errors.
          </p>
        </header>

        <section className="returns__details container">
          <h2 className="returns__section-title">Details</h2>

          <h3 className="returns__sub">Non-returnable Items</h3>
          <ul className="returns__list">
            <li>Items without an original receipt or gift receipt.</li>
            <li>Gift Cards.</li>
            <li>
              All custom or made-to-order items including lighting, furniture,
              door sets, shower sets and plumbing.
            </li>
            <li>Final sale items (with prices ending in $.97 or $.99).</li>
            <li>Items damaged through normal wear and tear.</li>
            <li>Items shipped directly from vendor.</li>
            <li>Retteve Vintage items.</li>
          </ul>

          <h3 className="returns__sub">Refund Policy</h3>
          <ul className="returns__list">
            <li>
              <strong>Original Receipt:</strong> A receipt is required for all
              returns and exchanges. Returns will be refunded in the original
              form of payment.
            </li>
            <li>
              <strong>Gift Receipt:</strong> Returns with a gift receipt will be
              refunded in the form of a Merchandise Credit for the amount on the
              gift receipt.
            </li>
            <li>
              <strong>Delivery Fees:</strong> Delivery fees are not refundable
              and prior purchases are not eligible for price adjustments.
            </li>
            <li>
              Depending on the reason for your return, you may be responsible
              for return shipping costs.
            </li>
            <li>
              <strong>Cash &amp; Check Refunds:</strong> Cash and check refunds
              over $100 will be issued as a company check and mailed to you (may
              take 14 business days).
            </li>
            <li>
              <strong>Contact Us:</strong> General Customer Service:{" "}
              <Link onClick={toTop} to="tel:8884011900">
                888-401-1900
              </Link>
            </li>
          </ul>
        </section>
      </div>

      <Footer />
    </div>
  );
}

export default Returns;
